<template>
  <div class="max-w-[80%] self-start bg-gpx_gray-900 text-gpx_black-500 rounded-xl p-2.5 ml-2">
    <div class="flex items-center space-x-2">
      <div class="w-1.5 h-1.5 rounded-full bg-gpx_gray-700 animate-typing-1"></div>
      <div class="w-1.5 h-1.5 rounded-full bg-gpx_gray-700 animate-typing-2"></div>
      <div class="w-1.5 h-1.5 rounded-full bg-gpx_gray-700 animate-typing-3"></div>
    </div>
    <div class="text-xs opacity-70 mt-1 text-right text-gpx_gray-700"></div>
  </div>
</template>

<script setup>
// Typing indicator component, shows animated dots
</script>

<style scoped>
.animate-typing-1 {
  animation: typingAnimation 1s infinite;
}

.animate-typing-2 {
  animation: typingAnimation 1s infinite;
  animation-delay: 0.2s;
}

.animate-typing-3 {
  animation: typingAnimation 1s infinite;
  animation-delay: 0.4s;
}

@keyframes typingAnimation {
  0% {
    opacity: 0.3;
    transform: translateY(0px);
  }
  50% {
    opacity: 1;
    transform: translateY(-2px);
  }
  100% {
    opacity: 0.3;
    transform: translateY(0px);
  }
}
</style>
